export default "__VITE_ASSET__Csry4gTq__"